import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionManyThanks = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"type": "page",
			"properties": {
				"title": [
					[
						"Благодарности"
					]
				]
			},
			"content": [
				"d95a2177-b1c9-409f-90cf-03329a3ab2bb",
				"3b4fe819-1c7a-4f90-9173-f94ce14adc41",
				"a7f90ed8-ec5e-4bf0-b79f-03de64e43a59",
				"1c169891-5252-41d6-ba60-3963d2cdde59",
				"593c0346-f6de-4202-b20b-2b8adba4c7e3",
				"47a047cf-48fc-4820-8137-ad952889f4cb",
				"71387da8-7089-466f-b22a-1fe8de813bf9",
				"7c564f9c-7630-4b0e-a8e3-a8a214f7a9ca",
				"d17768a2-0d0a-41ee-87f0-ffd5da071224",
				"ac32981b-2567-4269-ba0f-2c06bee43227",
				"6b3df1be-21ff-4b9b-a551-40b66069ab9b",
				"14f7bdc1-df80-4587-83ae-30719c145451",
				"5f631695-bfd0-41e8-bc27-a0546a9630d2",
				"a70fe34e-f141-43de-9d82-190083aa69ba",
				"b932f796-f6e4-45e1-9d92-d6b6ef963e44",
				"29197a6c-2fad-4860-8900-87c6cf9a532d",
				"5418e6b1-d943-449c-a415-d1d684172a88",
				"31b57367-cff8-47ad-83fa-77676e330a14",
				"ad121949-afb5-4d98-8051-657e447fdc19",
				"66c0cac8-314c-41eb-9ac5-2161baa773de",
				"b1970bc5-97d2-4f06-9bc0-18c5b6473a39",
				"cf05e365-f107-48d9-b2df-859d022949fd",
				"f41ffdd4-7a50-4d14-8514-63a06dd66231",
				"b96048dd-1a94-4183-9af0-6996eda6e75c",
				"27177c4f-df8c-40fe-95f3-8d358384c0d0",
				"bc8cb301-ff71-4e80-be76-68db79295c1d",
				"28d89281-ee32-49ef-9a89-7b7a2e776e38",
				"c2e0bad9-5aa4-4980-9bd6-781df7c9e4d2",
				"91220228-0715-4f42-9f37-0b77544966dc",
				"25f7ba51-1bef-4ae3-9e9a-c52ea45a98c2",
				"9941e913-4a8f-46e2-ae1c-5f29ba398b9e",
				"d6a392e6-fcd9-4a1a-bea9-a89abbd48912",
				"72e536f8-a13a-4703-8921-efff4441cb44",
				"658fcc93-d251-47a4-8b2f-8cc138edd6cc",
				"70f58aaa-b6f5-40ec-b380-a81b2e5eea3a",
				"8a113824-3162-4d7c-922e-1cb0c6f23b65",
				"79aff63a-8eb3-4ee0-b67a-42610b83b44f",
				"7c00d207-09d2-4c1b-98b4-ad52a7c49275",
				"40951a44-ad5d-4f2e-9c5f-2bd90fc1bda3",
				"aa442c40-42f7-4851-8931-88958a106dd9",
				"a20c0eaf-dafb-46e3-9aee-7b61fce9cad1",
				"b7ad1de2-435a-422b-9c65-e43626029585",
				"ab9cd493-f6a9-4d04-bc22-2571dc5db5d5",
				"e8dce59c-1dc6-4f87-81b2-fa84e87691be",
				"7f935b97-17c3-47b5-b86b-349f52f70920",
				"ce6a6cdf-7e15-4d79-a6a8-948c0e566046",
				"cc2965bb-a3c8-4437-918b-d88597908921",
				"133c14cc-55dc-424a-8c6d-97d728e45cdf",
				"cd089cc4-bfd9-4107-9d11-7cf24f98998f"
			],
			"format": {
				"copied_from_pointer": {
					"id": "c5ebe395-d557-4fc7-ba2f-c17e9d902128",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"245f158c-809f-4ad8-8ba9-c14506f5a800"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d95a2177-b1c9-409f-90cf-03329a3ab2bb",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/many_thanks\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "789f328d-8ce0-4d12-9843-8f0a3041d273",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3b4fe819-1c7a-4f90-9173-f94ce14adc41",
			"type": "text",
			"properties": {
				"title": [
					[
						"За годы существования дизайн-системы над ней поработало множество сильных специалистов. Хочется поблагодарить всех. Вот они — герои Paradigm:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0e256fb4-6097-4f90-a78a-e0c8f5087225",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f90ed8-ec5e-4bf0-b79f-03de64e43a59",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Саша Киров",
						[
							[
								"b"
							]
						]
					],
					[
						" — первый UI-кит для мобильных"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "801786dd-87b2-4c2b-b82e-a9a915d35095",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1c169891-5252-41d6-ba60-3963d2cdde59",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Антон Епрев",
						[
							[
								"b"
							]
						]
					],
					[
						" — реализация первого прототипа компонентной системы, фреймворк компонентной системы fest"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "fc236665-4a71-4c2a-8cf6-2fff49ce3283",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "593c0346-f6de-4202-b20b-2b8adba4c7e3",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Женя Беляев",
						[
							[
								"b"
							]
						]
					],
					[
						" — мобильный веб, основа гайдлайна для Android"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "858de944-57e1-49b4-b149-7b7a12bfba28",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "47a047cf-48fc-4820-8137-ad952889f4cb",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Дима Осадчук",
						[
							[
								"b"
							]
						]
					],
					[
						" — гайдлайны для комплексного редизайна медиапроектов, ставшие основой системы"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "228e6461-06b5-46da-88a4-a55f2a0add9d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "71387da8-7089-466f-b22a-1fe8de813bf9",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Лёша Сергеев",
						[
							[
								"b"
							]
						]
					],
					[
						" — основы гайдлайнов, синхронизация продуктовых линеек"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "cbd9eb29-d370-4533-80d7-fba23a8c84b3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7c564f9c-7630-4b0e-a8e3-a8a214f7a9ca",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Паша Скрипкин",
						[
							[
								"b"
							]
						]
					],
					[
						" — основа масштабируемой системы, основы для гайдлайнов Android и iOS, портальная навигация"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "64985081-1e17-434d-b6db-47de54108f62",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d17768a2-0d0a-41ee-87f0-ffd5da071224",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Геворг Глечян",
						[
							[
								"b"
							]
						]
					],
					[
						" — масштабируемость дизайн-системы для медиапроектов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6f6f49bf-725a-4519-96e9-3476f269881a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ac32981b-2567-4269-ba0f-2c06bee43227",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Артём Гладков",
						[
							[
								"b"
							]
						]
					],
					[
						" — обновление Почты Mail.ru как основа для дизайна productivity-сервисов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "cc829822-d56c-432c-8e5d-da6045c2fd07",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6b3df1be-21ff-4b9b-a551-40b66069ab9b",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Женя Долгов",
						[
							[
								"b"
							]
						]
					],
					[
						" — визуальный стиль: иллюстрации, иконки, промосайты, промописьма"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "55d832ee-ae5a-46b8-b89f-29b91eeaa936",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "14f7bdc1-df80-4587-83ae-30719c145451",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Андрей Сундиев",
						[
							[
								"b"
							]
						]
					],
					[
						" — идеология и масштабируемость системы, вёрстка и развитие первой версии сайта Paradigm, развитие для productivity-сервисов, первое поколение токенов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a087dc59-0eb2-40a7-ae78-6408451e7a41",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5f631695-bfd0-41e8-bc27-a0546a9630d2",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Юра Ветров",
						[
							[
								"b"
							]
						]
					],
					[
						" — идеология и основа масштабируемой системы, основы гайдлайнов по продуктовым линейкам и их синхронизация, второе поколение токенов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e33a5ddc-3ac6-40d6-8099-64fb763cb2ac",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a70fe34e-f141-43de-9d82-190083aa69ba",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Маша Боброва",
						[
							[
								"b"
							]
						]
					],
					[
						" — развитие productivity-сервисов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8748f0da-375f-4078-aad7-0c2e2d87ee65",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b932f796-f6e4-45e1-9d92-d6b6ef963e44",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Слава Яшков",
						[
							[
								"b"
							]
						]
					],
					[
						" — основа гайдлайна для iOS"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a9a8f7fe-68e5-4745-a008-fab32473c2b9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "29197a6c-2fad-4860-8900-87c6cf9a532d",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Света Соловьёва",
						[
							[
								"b"
							]
						]
					],
					[
						" — новое поколение мобильного веба, новый дизайн интерфейсов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3012741b-2182-470f-ba0f-7a0597c2c40a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5418e6b1-d943-449c-a415-d1d684172a88",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Женя Ферулёв",
						[
							[
								"b"
							]
						]
					],
					[
						" — развитие медиапроектов, новые компоненты медиапроектов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "cb6571fa-e50c-4dc7-b5b5-2cd39832fbe8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "31b57367-cff8-47ad-83fa-77676e330a14",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Лёша Кандауров",
						[
							[
								"b"
							]
						]
					],
					[
						" — основа для productivity-сервисов, развитие медиапроектов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c20f5db9-7276-4e91-9990-6caec054f519",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ad121949-afb5-4d98-8051-657e447fdc19",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Сергей Сивухин",
						[
							[
								"b"
							]
						]
					],
					[
						" — обновление дизайна интерфейсов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7b38962f-9214-4712-8990-60b5418f76b4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "66c0cac8-314c-41eb-9ac5-2161baa773de",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Константин Зубанов",
						[
							[
								"b"
							]
						]
					],
					[
						" — развитие сайта Paradigm, третье поколение токенов, обновление дизайна интерфейсов и стратегия развития дизайн-системы"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e8c68a02-c6d1-4609-bf15-18ae9cacac4f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b1970bc5-97d2-4f06-9bc0-18c5b6473a39",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Валерий Сироткин",
						[
							[
								"b"
							]
						]
					],
					[
						" — проработка единого подхода к UI-китам, обновление портальной навигации, документация с гайдлайнами и описанием процессов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "dd3f5a1c-7522-498f-8394-1ff389caa09b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cf05e365-f107-48d9-b2df-859d022949fd",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Саша Ермоленко",
						[
							[
								"b"
							]
						]
					],
					[
						" — стратегия развития дизайн-системы, синхронизация между командами, доступность в интерфейсах, развитие визуального дизайна: стилистика иллюстраций и визуальный язык коммуникаций "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "256bfa35-982d-4c77-b534-c861b44a40b4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f41ffdd4-7a50-4d14-8514-63a06dd66231",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Павел Шнейдер",
						[
							[
								"b"
							]
						]
					],
					[
						" — обновление стиля Почты Mail.ru, основа дизайна для e-mail рассылок, концепция визуального языка коммуникаций"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d44db352-4396-4c37-9059-6ecda212b76f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b96048dd-1a94-4183-9af0-6996eda6e75c",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Лаша Касоев",
						[
							[
								"b"
							]
						]
					],
					[
						" — основа дизайна для гайдлайна email-рассылок"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "57910479-a2f7-4715-83c8-8cd85d5c46b3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "27177c4f-df8c-40fe-95f3-8d358384c0d0",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Даша Гуща",
						[
							[
								"b"
							]
						]
					],
					[
						" — помощь в создании гайдлайна email-рассылок"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "72489cca-e8f1-4843-a697-a3ce29239e93",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bc8cb301-ff71-4e80-be76-68db79295c1d",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Катя Никулина",
						[
							[
								"b"
							]
						]
					],
					[
						" — развитие Почты Mail.ru и масштабирование дизайна продуктивити на множество других проектов, тёмная тема, суперапп"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "74a2f364-e941-40ed-a3fa-a80aff2a8aa4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "28d89281-ee32-49ef-9a89-7b7a2e776e38",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Даша Спесивцева",
						[
							[
								"b"
							]
						]
					],
					[
						" — развитие дизайна продуктивити-сервисов, суперапп"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6d8b4d94-9d08-4913-aa07-196e66bbaa09",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c2e0bad9-5aa4-4980-9bd6-781df7c9e4d2",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Алина Пастухова",
						[
							[
								"b"
							]
						]
					],
					[
						" — развитие гайдлайна email-рассылок"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d6dea3e2-1d2d-4f03-b67d-99b3e2064f21",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "91220228-0715-4f42-9f37-0b77544966dc",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Денис Жуков",
						[
							[
								"b"
							]
						]
					],
					[
						" — обновление библиотеки Paradigm для Figma Community"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8ed3c244-1100-4f10-aee8-60a09f6c6675",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "25f7ba51-1bef-4ae3-9e9a-c52ea45a98c2",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Анна Жаворонкова",
						[
							[
								"b"
							]
						]
					],
					[
						" — обновление библиотеки Paradigm для Figma Community"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "383596f9-bcc5-4846-a9e8-3026ecefd732",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9941e913-4a8f-46e2-ae1c-5f29ba398b9e",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Паша Прошин",
						[
							[
								"b"
							]
						]
					],
					[
						" — развитие визуального дизайна интерфейсов (веб-версия Облака)"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "4e6b1d78-a818-4d6c-a09a-a4199de7b52e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d6a392e6-fcd9-4a1a-bea9-a89abbd48912",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Вова Васильев",
						[
							[
								"b"
							]
						]
					],
					[
						" — развитие визуального дизайна интерфейсов (веб-версия Облака)"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "27259ff7-b0a7-4143-b4d5-e6ea6e47e747",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "72e536f8-a13a-4703-8921-efff4441cb44",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Даша Ломова",
						[
							[
								"b"
							]
						]
					],
					[
						" — развитие визуального дизайна интерфейсов (мобильная версия Облака)"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f46fc399-277a-4842-8197-c53ff0461f90",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "658fcc93-d251-47a4-8b2f-8cc138edd6cc",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Акдиль Эрнисов",
						[
							[
								"b"
							]
						]
					],
					[
						" — развитие визуального дизайна интерфейсов Облака и создание библиотеки компонентов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d30706ae-dee8-4cf4-a8f6-d4dd8d6e45bb",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "70f58aaa-b6f5-40ec-b380-a81b2e5eea3a",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Коля Комисаров",
						[
							[
								"b"
							]
						]
					],
					[
						" — развитие дизайна медиапроектов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "754c6121-77c5-4e4f-9ee3-12c76c2e78cf",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8a113824-3162-4d7c-922e-1cb0c6f23b65",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Никита Кожевников",
						[
							[
								"b"
							]
						]
					],
					[
						" — помощь в написании редполитики"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "99e92a58-693f-422b-a1c8-73de4260d554",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "79aff63a-8eb3-4ee0-b67a-42610b83b44f",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Костя Лебедев",
						[
							[
								"b"
							]
						]
					],
					[
						" — фреймворк компонентной системы feast"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a10f3817-c490-4e35-94af-887239185012",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7c00d207-09d2-4c1b-98b4-ad52a7c49275",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Разработка медиапроектов и мобильного веба — "
					],
					[
						"Александр Бекбулатов",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Дмитрий Беляев",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Виталий Васин",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Павел Вдовцев",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Костя Ворожейкин",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Женя Иванов",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Андрей Кусимов",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Стас Михальский",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Сергей Ножкин",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Антон Полещук",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Борис Ребров",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Паша Рыбин",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Макс Трусов",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Арсен Карапетян",
						[
							[
								"b"
							]
						]
					],
					[
						", …"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f149faa7-b322-4888-b0fa-1bb5e7200160",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "40951a44-ad5d-4f2e-9c5f-2bd90fc1bda3",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Разработка продутивити-сервисов — "
					],
					[
						"Илья Бурлак",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Артём Мезин",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Стас Туговиков",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Артур Удалов",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Егор Утробин",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Вика Камолдинова",
						[
							[
								"b"
							]
						]
					],
					[
						", "
					],
					[
						"Сергей Володин",
						[
							[
								"b"
							]
						]
					],
					[
						", … "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ea36fde4-e4de-477b-8cee-f17d458f8094",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "aa442c40-42f7-4851-8931-88958a106dd9",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Алексей Судиловский",
						[
							[
								"b"
							]
						]
					],
					[
						" — консультации и поддержка по технической стороне вопроса"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "614c0b0b-69f7-44c6-8cf5-0f190ca26381",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a20c0eaf-dafb-46e3-9aee-7b61fce9cad1",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Егор Утробин",
						[
							[
								"b"
							]
						]
					],
					[
						" — руководитель команды разработки"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e72d46ad-805d-4d5c-9181-f3bcf0f0dcf7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b7ad1de2-435a-422b-9c65-e43626029585",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Кирилл Гаджиев",
						[
							[
								"b"
							]
						]
					],
					[
						" — разработка конструктора рассылок"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1499c169-394a-4b51-921f-d0c048cb8e39",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ab9cd493-f6a9-4d04-bc22-2571dc5db5d5",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Лиза Щербакова",
						[
							[
								"b"
							]
						]
					],
					[
						" — разработка и поддержка сайта Paradigm"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ecdfdbd7-cbe2-4416-939b-5f9d93512597",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e8dce59c-1dc6-4f87-81b2-fa84e87691be",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Женя Барсукова",
						[
							[
								"b"
							]
						]
					],
					[
						" — разработка и поддержка сайта Paradigm и дизайн-токенов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b07a8e49-ebc2-4253-b56e-a5c54a72b30b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7f935b97-17c3-47b5-b86b-349f52f70920",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Иван Чашкин",
						[
							[
								"b"
							]
						]
					],
					[
						" — руководитель команды разработки"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b41cd0a3-b188-4f1d-9d25-3df6ebefa913",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ce6a6cdf-7e15-4d79-a6a8-948c0e566046",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Сергей Володин",
						[
							[
								"b"
							]
						]
					],
					[
						" — разработка и развитие дизайн-токенов, компонентного фреймворка продуктивити сервисов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6d171136-970d-4541-aa38-8eccfe1f2546",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cc2965bb-a3c8-4437-918b-d88597908921",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Маргарита Козырева",
						[
							[
								"b"
							]
						]
					],
					[
						" — разработка текущей версии сайта и переход на Notion API"
					]
				]
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "133c14cc-55dc-424a-8c6d-97d728e45cdf",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Мария Титова",
						[
							[
								"b"
							]
						]
					],
					[
						" — написание раздела редполитики"
					]
				]
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cd089cc4-bfd9-4107-9d11-7cf24f98998f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Надеемся, никого не забыли. Если по случайному недоразумению вас нет в списке, напишите "
					],
					[
						"Валере",
						[
							[
								"a",
								"https://www.facebook.com/fliqle",
								true
							]
						]
					],
					[
						"."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0092e3d3-327b-4eaa-9944-d0df208dd9af",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c7ec9e06-de22-4861-88e6-e6d45e0de285",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": []
}} />
);

export default NotionManyThanks;
